<template>
  <ul class="pagination p-2 rounded">
    <span class="pagination-item-actions">
      <li
        class="pagination-item pagination-item-action"
        :class="{ disabled: page === 1 || loading }"
      >
        <a @click.prevent="$emit('changePage', 1)" href="#">
          <chevrons-left viewBox="0 0 24 24"></chevrons-left>
        </a>
      </li>

      <li
        class="pagination-item pagination-item-action"
        :class="{ disabled: page === 1 || loading }"
      >
        <a @click.prevent="handlePrevPage" href="#">
          <chevron-left viewBox="0 0 24 24"></chevron-left>
        </a>
      </li>
    </span>

    <li
      class="pagination-item pagination-item--page"
      v-for="pagi in showPagination"
      :key="pagi"
      :class="{
        active: page === pagi,
        ellipsis: pagi === '...',
        disabled: loading,
      }"
    >
      <a href="#" @click.prevent="changePage(pagi)">
        {{ pagi }}
      </a>
    </li>

    <div class="pagination-item-actions pagination-item-actions--end">
      <li
        class="pagination-item pagination-item-action"
        :class="{ disabled: page === lastPage || loading }"
      >
        <a @click.prevent="handleNextPage" href="#">
          <chevron-right viewBox="0 0 24 24"></chevron-right>
        </a>
      </li>
      <li
        class="pagination-item pagination-item-action"
        :class="{ disabled: page === lastPage || loading }"
      >
        <a @click.prevent="$emit('changePage', lastPage)" href="#">
          <chevrons-right viewBox="0 0 24 24"></chevrons-right>
        </a>
      </li>
    </div>
  </ul>
</template>

<script>
import ChevronLeft from '@/assets/svg/chevron-left.svg?component'
import ChevronsLeft from '@/assets/svg/chevrons-left.svg?component'
import ChevronRight from '@/assets/svg/chevron-right.svg?component'
import ChevronsRight from '@/assets/svg/chevrons-right.svg?component'

export default {
  name: 'AppPagination',
  components: {
    ChevronLeft,
    ChevronsLeft,
    ChevronRight,
    ChevronsRight,
  },
  props: {
    page: {
      type: Number,
      default: 1,
      required: true,
    },
    totalPages: {
      type: Number,
      default: 10,
    },
    lastPage: {
      type: Number,
      default: null,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showPagination() {
      return this.pagination(this.lastPage, this.page, 3)
    },
  },
  methods: {
    handlePrevPage() {
      const page = this.page - 1

      return this.page <= 1
        ? this.$emit('changePage', 1)
        : this.$emit('changePage', page)
    },
    handleNextPage() {
      const page = this.page + 1
      return this.page >= this.totalPages
        ? this.$emit('changePage', this.totalPages)
        : this.$emit('changePage', page)
    },
    changePage(page) {
      this.$emit('changePage', page)
    },
    pagination(totalPages, pageActive, positionOfEllipsis) {
      if (pageActive === void 0) {
        pageActive = 1
      }
      if (positionOfEllipsis === void 0) {
        positionOfEllipsis = 0
      }
      var newArray = []
      var maxPages =
        Number(totalPages) < Number(pageActive)
          ? Number(totalPages)
          : Number(pageActive)
      var minPages = Number(pageActive) < 1 ? 1 : Number(pageActive)
      var pageAddition = maxPages + Number(positionOfEllipsis)
      var pageSubtraction = minPages - Number(positionOfEllipsis)
      if (Number(positionOfEllipsis) === 0) {
        for (let i = 1; i <= Number(totalPages); i++) {
          newArray.push(Number(i))
        }
      } else {
        if (minPages > 1) {
          for (let i = pageSubtraction; i < minPages; i++) {
            newArray.push(Number(i))
          }
        }
        for (let i = maxPages; i <= pageAddition; i++) {
          newArray.push(Number(i))
        }
      }
      const filterNegative = newArray.filter(function (num) {
        return Number(num) > 0
      })
      const filterMax = filterNegative.filter(function (num) {
        return Number(num) <= Number(totalPages)
      })
      if (
        pageAddition < Number(totalPages) &&
        Number(positionOfEllipsis) !== 0
      ) {
        filterMax.push('...')
      }
      if (pageSubtraction > 1 && Number(positionOfEllipsis) !== 0) {
        filterMax.unshift('...')
      }
      return filterMax
    },
  },
}
</script>

<style></style>
